import { createFileRoute } from '@tanstack/react-router';
import { guardDashboard } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const Dashboard = lazy(() => import('../../../../pages/Dashboard/Dashboard'));

export const Route = createFileRoute('/$lang/_authenticated/dashboard')({
  beforeLoad: guardDashboard,
  component: () => (
    <Suspense fallback={<Loading />}>
      <Dashboard />
    </Suspense>
  ),
});
